@if (data.type === Type.Success) {
  <div class="d-flex align-items-center">
    <mat-icon [fontIcon]="'mdi-check'" class="mr-2 success"></mat-icon>
    <div class="text">
      @if (!data.showOnlyMessage || !(data.message | async)?.length) {
        <span> {{ 'shared.updateSuccess' | translate }}</span>
        @if (data.message | async) {
          <span>:</span>
        }
      }
      @if (data.message) {
        <span> {{ data.message | async }}</span>
      }
    </div>
  </div>
}

@if (data.type === Type.Error) {
  <div class="d-flex align-items-center">
    <mat-icon [fontIcon]="'mdi-alert-circle'" class="pr-4" color="warn"></mat-icon>
    <div class="text pl-2">
      @if (!data.showOnlyMessage || (data.message | async) === undefined) {
        <span>
          {{ 'errors.defaultError' | translate }}
        </span>
      }
      @if (!data.showOnlyMessage && data.message) {
        <span>:</span>
      }
      @if (data.message) {
        <span> {{ data.message | async }}</span>
      }
    </div>
  </div>
}
